import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./store";
import { router } from "./routes";
import { TelegramConsentGate } from "./components/TelegramConsentGate";
import { InternationalHostAuthGate } from "./components/InternationalHostAuthGate";
import { usePlatformReadyAndExpand } from "./lib/platformChrome";
import { useAnalyticsBoot } from "./lib/analytics";
// Must be imported before any component that calls useTranslation so the
// i18next instance is initialized on the first render.
import "./i18n";

export default function App() {
  usePlatformReadyAndExpand();
  useAnalyticsBoot();
  return (
    <AppProvider>
      <TelegramConsentGate>
        <InternationalHostAuthGate>
          <RouterProvider router={router} />
        </InternationalHostAuthGate>
      </TelegramConsentGate>
      <Toaster position="bottom-center" richColors />
    </AppProvider>
  );
}
